import React from "react"

const RenapoContext = React.createContext({ Token: "", Name: "", LastnameP: "", LastnameM: "", Genere: undefined, Year: undefined, Month: undefined, Day: undefined, IDdocumento: 0, Date: undefined, code: 0 });

export default RenapoContext;
